// /** @jsxImportSource @emotion/react */
import tw, { css } from "twin.macro";
import styled from 'styled-components';
import { Button, Icon, SelectorButton } from '@selfbook/atoms-v2';
import { POPOUT_DIRECTION } from '../hooks';

const sharedButtonStyles = (props) => css`
  padding: 11px 16px;
  ${props.$active && !props.isSkeleton && props.variant === 'ghost' ? `
    background-color: ${props.theme?.get(`ui.button.ghost.${props.colorTheme || 'light'}.hover`)};
  ` : null}
  ${props.$flex === 'none' ? tw`flex-none`
    : props.$flex === 'auto' ? tw`flex-1`
    : props.$flex === 'shrink' ? tw`flex-shrink`
    : null}
  ${props.$overflowText ? `
    min-width: 0;
    white-space: nowrap;

    & > div {
      flex: none;
      width: 100%;
      min-width: 0;
    }
  ` : null}
`;

export const ButtonStyled = styled(Button)`
  ${sharedButtonStyles}
`;

export const SelectorButtonStyled = styled(SelectorButton)`
  ${sharedButtonStyles}
`;

export const Popout = styled.div`
  ${tw`absolute bg-widget-bg left-0 z-10 box-border rounded-modal`}
  ${({ $colorTheme, $theme }) => `
    background-color: var(--sb-widget-bgcolor, ${$theme?.get(`tokens.surface.${$colorTheme || 'light'}.background`) || '#FFFFFF'});
  `}
  ${({ $position }) => $position === POPOUT_DIRECTION.TOP ? tw`bottom-[calc(100% + var(--popout-offset, 8px))]` : tw`top-[calc(100% + var(--popout-offset, 8px))]`}
  ${({ $centered }) => !!$centered && tw`left-[calc(50% - 230px)] w-[460px]`}
  ${({ $scrollable }) => !!$scrollable && tw`flex flex-col max-h-[440px]`}
`;

export const ResponsiveText = styled.div`
  &::before {
    content: attr(data-text-mobile);
    display: block;
  }
  
  & .responstive-text__desktop {
    display: none;
  }

  ${({ $theme, $breakpoint }) => `
    @media ${$theme?.get(`tokens.breakpoints.${$breakpoint || 'medium'}`).toExpression()} {
      &::before {
        content: none;
        display: none;
      }

      & .responstive-text__desktop {
        display: block;
      }
    }
  `}
`;
